import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { RehabImpMarketsMst, RehabImpMarketsMstData } from '../../../interfaces/masters/rehab-imp-markets-mst';
import { RehabImpMarketsMstApi } from '../api/rehab-imp-markets-mst.api';

@Injectable()
export class RehabImpMarketsMstService extends RehabImpMarketsMstData{

  constructor(private api: RehabImpMarketsMstApi) { 
    super();
  }
  list(url: string): Observable<RehabImpMarketsMst[]> { 
    return this.api.list(url);
  } 

  getById(url:string): Observable<RehabImpMarketsMst>{
      return this.api.getById(url);
  }
  create(url: string, data:RehabImpMarketsMst): Observable<RehabImpMarketsMst[]> {
    return this.api.add(url,data);
  }

  update(url: string, data:RehabImpMarketsMst): Observable<RehabImpMarketsMst> { 
    return this.api.update(url,data);
  }  

  delete(url: string): Observable<boolean> {
    return this.api.delete(url);
  }
}
